import { render, staticRenderFns } from "./AddNewPaymentMethodDialog.vue?vue&type=template&id=1a4b1bc3&"
import script from "./AddNewPaymentMethodDialog.vue?vue&type=script&lang=ts&"
export * from "./AddNewPaymentMethodDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewPaymentMethodDialog.vue?vue&type=style&index=0&id=1a4b1bc3&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions})
